module.exports = __webpack_public_path__ + "static/media/billboard_banner_default_375.90a62058.png";